import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getTrustDeviceV2Token } from '@/service/ys7'

function parseYs7SuccessData(responseData) {
  const inner = responseData?.data !== undefined ? responseData.data : responseData
  return inner
}

async function resolveTrustAccessTokenFromEnv ({ rejectWithValue }) {
  const appKey = process.env.REACT_APP_EZVIZ_APP_KEY
  const appSecret = process.env.REACT_APP_EZVIZ_SECRET
  if (!appKey || !appSecret) {
    return rejectWithValue('未配置 REACT_APP_EZVIZ_APP_KEY / REACT_APP_EZVIZ_SECRET')
  }

  const tokenRes = await getTrustDeviceV2Token({ appKey, appSecret })
  const tokenPayload = tokenRes?.data
  const code = tokenPayload?.code
  if (code !== '200' && code !== 200) {
    return rejectWithValue(tokenPayload?.msg || '获取托管 token 失败')
  }
  const tokenData = parseYs7SuccessData(tokenPayload)
  const trustAccessToken =
    tokenData?.accessToken ?? tokenData?.data?.accessToken ?? tokenData?.access_token

  if (!trustAccessToken) {
    return rejectWithValue('托管 token 响应中无 accessToken')
  }
  return trustAccessToken
}

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  /** 托管授权 token，抓拍/取流用（非账号 ys7Token） */
  trustAccessToken: '',
  data: {}
}

/**
 * 换取托管 token（抓拍/取流用）。
 * appKey / appSecret 来自 REACT_APP_EZVIZ_APP_KEY、REACT_APP_EZVIZ_SECRET。
 */
export const fetchTrustAccessToken = createAsyncThunk(
  'ys7Nvr/fetchTrustAccessToken',
  async (_, { rejectWithValue }) => {
    try {
      const trustAccessToken = await resolveTrustAccessTokenFromEnv({ rejectWithValue })
      if (typeof trustAccessToken !== 'string') {
        return trustAccessToken
      }
      return { trustAccessToken }
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message || '获取托管 token 失败')
    }
  }
)

const nvrSlice = createSlice({
  name: 'ys7Nvr',
  initialState: defaultState,
  reducers: {
    resetNvrState: () => defaultState
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrustAccessToken.pending, (state) => {
        state.fetching = true
        state.error = null
      })
      .addCase(fetchTrustAccessToken.fulfilled, (state, action) => {
        state.fetching = false
        state.error = null
        state.trustAccessToken = action.payload?.trustAccessToken || ''
      })
      .addCase(fetchTrustAccessToken.rejected, (state, action) => {
        state.fetching = false
        state.error = action.payload
        state.trustAccessToken = ''
      })
  }
})

export const { resetNvrState } = nvrSlice.actions
export default nvrSlice.reducer
